export default __webpack_public_path__ + "static/media/schwab.a6f260f8.jpg";